import React from "react";
import { CheckCircle } from "lucide-react";
import { CarouselItem } from "./ui/carousel";

function ResultItem({ text }) {
  return (
    <div className="flex items-start gap-3 p-4 bg-[#f5f5f5] rounded-xl group-hover:bg-[#4a9da8]/5 transition-colors">
      <CheckCircle className="w-5 h-5 text-[#4a9da8] flex-shrink-0 mt-0.5" />
      <p className="text-[#3a3a3a] text-sm leading-relaxed font-medium">{text}</p>
    </div>
  );
}

function CaseStudySlide({ study, index }) {
  const hasLogo = study.logo;
  return (
    <CarouselItem
      key={index}
      className="pl-2 md:pl-4 basis-full md:basis-full"
    >
      <div className="group card-hover bg-white border-2 border-[#e8e4dc] hover:border-[#4a9da8]/30 rounded-3xl p-8 md:p-12 transition-all duration-300">
        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/3">
            <div
              className={
                "inline-flex items-center justify-center min-w-[4rem] min-h-[4rem] w-20 h-20 bg-gradient-to-br " +
                study.gradient +
                " rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300 p-2"
              }
            >
              {hasLogo ? (
                <img
                  src={study.logo}
                  alt={`Logo ${study.title}`}
                  className="max-w-full max-h-full w-full h-full object-contain"
                />
              ) : (
                <span className="w-8 h-8 text-white font-bold text-xl">?</span>
              )}
            </div>
            <h3 className="text-3xl font-bold text-[#0f1419] mb-2 group-hover:text-[#4a9da8] transition-colors">
              {study.title}
            </h3>
            <span className="inline-block px-3 py-1 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full">
              {study.tag}
            </span>
          </div>

          <div className="lg:w-2/3 space-y-6">
            <div className="grid md:grid-cols-2 gap-6">
              <div className="accent-line">
                <h4 className="text-sm font-bold text-[#3a3a3a]/60 uppercase tracking-wider mb-3">
                  Ausgangssituation
                </h4>
                <p className="text-[#3a3a3a] leading-relaxed">
                  {study.situation}
                </p>
              </div>
              <div className="accent-line">
                <h4 className="text-sm font-bold text-[#3a3a3a]/60 uppercase tracking-wider mb-3">
                  Lösung
                </h4>
                <p className="text-[#3a3a3a] leading-relaxed">
                  {study.solution}
                </p>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-[#3a3a3a]/60 uppercase tracking-wider mb-4">
                Ergebnisse
              </h4>
              <div className="grid md:grid-cols-3 gap-4">
                <ResultItem text={study.results[0]} />
                <ResultItem text={study.results[1]} />
                <ResultItem text={study.results[2]} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </CarouselItem>
  );
}

export default CaseStudySlide;
